import { Card } from "@mui/material";
import { styled } from "@mui/system";

const TimelineContainer = styled(Card)({
  width: "100%",
  height: "100%",
  maxWidth: 400,
  margin: "0 auto",
  borderRadius: 8,
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
  overflowY: "auto",
  maxHeight: 700,
});

export default TimelineContainer;
